import { queryCache } from 'react-query';
import { useSelector } from 'react-redux';

const useAlgoliaLocalizedLanguages = () => {
  const language = useSelector(state => state.main.language);
  const localizedLanguage = queryCache.getQueryData(['language', language]);
  return localizedLanguage && localizedLanguage.slug !== 'english'
    ? [localizedLanguage.title]
    : [];
};

export default useAlgoliaLocalizedLanguages;
